angular.module('lsnBase.deprecated.models')
  .factory('ApplicationAllowedChangesSubjectsModel', ['LsnApplicationAllowedChangesSubjectsModelV1',
    function(LsnApplicationAllowedChangesSubjectsModelV1) {
      return LsnApplicationAllowedChangesSubjectsModelV1;
    }
  ]);